import axios from 'axios'
import store from '../../store/index'

const state = {
  appThirdPartySettings: {},
}

const mutations = {
  appThirdPartySettings_data (state, appSettings) {
    state.appThirdPartySettings = appSettings
  },
}

const actions = {
  postAppThirdPartySettings ({ commit }, appSettings) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/thirdApis',
        data: appSettings,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  patchAppThirdPartySettings ({ commit }, objModel) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/thirdApis?appThirdPartyId=' + objModel.appThirdPartyId,
        data: objModel.data,
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getAppThirdPartySettings ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/thirdApis/list',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getAppThirdPartyTypes ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/thirdApis/types',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteAppThirdPartySettings ({ commit }, appThirdPartyId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/thirdApis?appThirdPartyId=' + appThirdPartyId,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getAppThirdPartySetting ({ commit }, appThirdPartyId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/thirdApis?appThirdPartyId=' + appThirdPartyId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
